import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from '@/components/SearchBar/';
import { env } from '@/env';
import { RetailerState } from '@/store/slices/retailerSlice';

interface TopInfoSearchBarProps {
  retailerInfo?: RetailerState;
  setSearchTerm(searchTerm: string): void;
  searchTerm: string;
}

const TopInfoSearchBar = (props: TopInfoSearchBarProps) => {
  const { retailerInfo, setSearchTerm, searchTerm } = props;
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center pt-4-0 pb-2-0 justify-between">
      {retailerInfo && (
        <div
          className="w-1/4 md:min-w-[36rem] max-w-[14rem] mr-3-0 md:mr-0 cursor-pointer"
          onClick={() => navigate('/' + retailerInfo.id)} // this can be used to clear the search filters as well...
        >
          <img
            src={`${env.VITE_STATIC_URL}/retailer/images/${retailerInfo.id}-logo.png`}
            className="max-h-[8rem]"
          />
        </div>
      )}
      <div className="w-full md:w-3/4 flex">
        <SearchBar
          className="md:w-3/5"
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
        />
        <div className="hidden md:block ml-6-0">
          {retailerInfo && (
            <>
              <p className="text-body1 font-bold">
                {i18n.t('retailer.support')}
              </p>
              <p className="text-body1 font-bold">{retailerInfo.phoneNumber}</p>
              <p className="text-body1 font-bold">{retailerInfo.website}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopInfoSearchBar;
